import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { PworkflowComponent } from '../index';
import { ServiceInterface } from 'services/service.interface';
import { stateConstant } from '../../../../constants';
import { Register, Questions } from '../../../models';
import * as sha1 from 'sha1';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(_services, _parent) {
        this._services = _services;
        this._parent = _parent;
        this.states = stateConstant;
        this.formClass = "";
        this.errormsg = new Array();
        this.errdisplay = false;
        this.login = new Register();
    }
    LoginComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this._parent.model = new Questions();
                return [2 /*return*/];
            });
        });
    };
    LoginComponent.prototype.clickSubmit = function (valid) {
        this.errormsg = [];
        if (valid) {
            this.loginsubmit();
        }
        else {
            if ($('#username-text').val() == "") {
                this.errdisplay = true;
                this.errormsg.push("Please enter username.");
            }
            if ($('#password-text').val() == "") {
                this.errdisplay = true;
                this.errormsg.push("Please enter password.");
            }
            this.formClass = "validate";
        }
    };
    LoginComponent.prototype.loginsubmit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var logininfo, loginData;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.errormsg = [];
                        logininfo = {
                            'uname': this.login.uname,
                            'password': sha1(this.login.password)
                        };
                        return [4 /*yield*/, this._services.post('/authenicate/login', logininfo)];
                    case 1:
                        loginData = _a.sent();
                        if (loginData.length == 1 && loginData[0].type == "user") {
                            this._parent.loginAction(loginData[0].uuid);
                        }
                        else {
                            if (loginData == "emailnotexist") {
                                this.errdisplay = true;
                                this.errormsg.push("User does not exist.");
                            }
                            else if (loginData == "wrongpassword") {
                                this.errdisplay = true;
                                this.errormsg.push("Wrong Password.");
                            }
                            else {
                                this.errdisplay = true;
                                this.errormsg.push("Invalid Login Information.");
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginComponent.prototype.searchData = function () {
        this._parent.index = 1;
    };
    return LoginComponent;
}());
export { LoginComponent };



// WEBPACK FOOTER //
// ./src/app/components/pworkflow/login/login.component.ts.pre-build-optimizer.js